import { ComponentUtils } from '@/mixins';

// @vue/component
export default {
  name: 'DayTimeSchedulerItem',

  mixins: [ComponentUtils],

  props: {
    day: {
      type: String,
      default: null,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    availabilityHoursFrom: {
      type: String,
      default: null,
    },
    availabilityHoursTo: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      daysLanguageMap: {
        monday: 'Poniedziałek',
        tuesday: 'Wtorek',
        wednesday: 'Środa',
        thursday: 'Czwartek',
        friday: 'Piątek',
        saturday: 'Sobota',
        sunday: 'Niedziela',
      },
      schedule: {
        isActive: this.isActive,
        availabilityHoursFrom: this.$filters.timeWithoutSeconds(this.availabilityHoursFrom),
        availabilityHoursTo: this.$filters.timeWithoutSeconds(this.availabilityHoursTo),
      },
    };
  },

  methods: {
    informAboutChanges() {
      const newSchedule = {
        isActive: this.schedule.isActive,
        availabilityHoursFrom: this.schedule.availabilityHoursFrom,
        availabilityHoursTo: this.schedule.availabilityHoursTo,
      };
      this.$emit('change', this.day, newSchedule);
    },
  },
};
